import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import MetaTags from "react-meta-tags"
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  CardText,
  CardHeader,
  Input,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { sitename } from "constants/constants"
import { getAffiliatesCall } from "helpers/repository"
import { showErrorMessages } from "helpers/helpers"

const ReferralReport = props => {
  const [summary, setSummary] = useState({})
  const [search, setSearch] = useState("")

  const call = async () => {
    try {
      const response = await getAffiliatesCall({ search, per_page: 15 })
      const result = response?.data?.data || {}

      setSummary(result.summary || {})
    } catch (error) {
      showErrorMessages(error)
    }
  }

  useEffect(() => {
    call()
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      call()
    }, 400)
    return () => clearTimeout(timeout)
  }, [search])

  const summaryCards = [
    { label: "Total Affiliates", value: summary.total_affiliates },
    { label: "Total Signups", value: summary.total_signups },
    { label: "Total Clicks", value: summary.total_clicks },
    { label: "First Time Deposits", value: summary.total_first_time_deposits },
    { label: "Total Wagers", value: summary.total_wagers },
    { label: "Total Winnings", value: summary.total_winnings },
    { label: "Total Earnings", value: summary.total_earnings },
    { label: "Total Paid", value: summary.total_paid },
    { label: "Total Unpaid", value: summary.total_unpaid },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Affiliate" breadcrumbItem="Dashboard" />
        </Container>
        <Row>
          {summaryCards.map(({ label, value }) => (
            <Col lg={3} key={label} className="mb-3">
              <Card className="mb-0">
                <CardHeader className="bg-transparent border-bottom text-uppercase">
                  {label}
                </CardHeader>
                <CardBody>
                  <blockquote className="card-blockquote mb-0">
                    <CardText className="font-size-16">
                      {Number(value || 0).toLocaleString()}
                    </CardText>
                  </blockquote>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
       
      </div>
    </React.Fragment>
  )
}

export default withRouter(ReferralReport)
